<div class="card">
  <p
    i18n
    class="my-0">
    U bent uitgelogd.
  </p>
  <p i18n>Terug naar <a routerLink="/login">Inloggen</a></p>
</div>
